import { Combobox as ComboboxPrimitive } from '@base-ui/react'
import { Button } from '@/components/ui/button'
import {
  Combobox,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
  ComboboxTrigger,
} from '@/components/ui/combobox'
import { cn } from '@/lib/utils'
import { AreaOption } from '@/utils/areas'

type OdinComboboxProps = {
  options: AreaOption[]
  selectedId?: string
  onSelect: (id: string) => void
  triggerPlaceholder: string
  searchPlaceholder: string
  noResultsLabel: string
  className?: string
}

export const OdinCombobox = ({
  options,
  selectedId,
  onSelect,
  triggerPlaceholder,
  searchPlaceholder,
  noResultsLabel,
  className,
}: OdinComboboxProps) => {
  const selected = options.find((option) => option.area._id === selectedId) ?? null

  return (
    <Combobox
      items={options}
      value={selected}
      onValueChange={(option: AreaOption | null) => option && onSelect(option.area._id)}
      itemToStringLabel={(option: AreaOption) => option.path.join(' › ')}
      isItemEqualToValue={(a: AreaOption, b: AreaOption) => a?.area._id === b?.area._id}
    >
      <ComboboxTrigger
        render={<Button variant="outline" className={cn('h-10 w-full justify-between px-3 font-normal', className)} />}
      >
        <ComboboxPrimitive.Value>
          {(value: AreaOption | null) => (
            <span className={cn('min-w-0 flex-1 truncate text-left', !value && 'text-muted-foreground')}>
              {value ? value.path.join(' › ') : triggerPlaceholder}
            </span>
          )}
        </ComboboxPrimitive.Value>
      </ComboboxTrigger>
      {/* min-w override: the stock content min-width (anchor + 28px) overflows narrow viewports,
          spawning page scrollbars that flicker on mobile. */}
      <ComboboxContent className="min-w-(--anchor-width)">
        <ComboboxInput showTrigger={false} placeholder={searchPlaceholder} />
        <ComboboxEmpty>{noResultsLabel}</ComboboxEmpty>
        <ComboboxList>
          {(option: AreaOption) => (
            <ComboboxItem key={option.area._id} value={option}>
              <span className="min-w-0 flex-1 truncate text-muted-foreground">
                {option.path.length > 1 && `${option.path.slice(0, -1).join(' › ')} › `}
                <span className="font-medium text-foreground">{option.path[option.path.length - 1]}</span>
              </span>
            </ComboboxItem>
          )}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  )
}
